import React, { useState } from "react";
import { Form } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";

export default function PlatformSpecific(props) {
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;
  const [semrushApiKey, setSemrushApiKey] = useState(props.organization.semrush_api_key);

  return (
    <>
      <div className="basic-info-container prim-bg" >
        <div className="pt-4 pb-2 mb-3 px-3">
          <h5>Platform specific data</h5>
        </div>
        <div style={{ maxWidth: "900px", justifyContent: "center", margin: "0 auto" }} className="mt-5 mb-5 px-3">
          <Form id="platform-specific-data" method="post" action="/datapulse/api-access">
            <input hidden name="authenticity_token" value={authenticityToken} readOnly />
            <input hidden name="org_id" value={props.organization.id} readOnly />
            <div className="d-flex flex-column">
              <div style={{ marginBottom: "20px" }}>
                <div style={{paddingBottom: "5px"}}>
                  <h5 className="pl-1" style={{ fontSize: "15px" }}>
                    Google Ads MCC ID (No '-'s):
                    <CustomTooltip faClass="far fa-question-circle pl-2" message={`This is required to send with Google Ads API calls. If you don't have an MCC account, just use your primary Google Ads account ID`} inline={true} />
                  </h5>
                  <p className={props.showAlert === true ? "ml-3 mcc-alert-text" : "d-none"}>
                    Please enter 10 digit MCC ID without dashes or spaces before continuing
                  </p>
                </div>
                <input
                  placeholder="Enter MCC ID"
                  value={props.mccId ? props.mccId : ""}
                  onChange={(e) => props.setMccId(e.target.value)}
                  name="google_ads_mcc_id"
                  className={props.showAlert === true ? "mcc-alert lite-input" : "lite-input"}
                />
              </div>
              <div>
                <h5 style={{ fontSize: "15px" }} className="pl-1">
                  SEMRush API Key:
                  <CustomTooltip faClass="far fa-question-circle pl-2" message={`Your SEMRush API key can be found by logging into semrush.com, clicking your avatar in the top right corner > Subscription Info > API Units`} inline={true} />
                </h5>
                <input
                  placeholder="Enter SEMRush API Key"
                  className="lite-input"
                  value={semrushApiKey ? semrushApiKey : ""}
                  onChange={(e) => setSemrushApiKey(e.target.value)}
                  name="semrush_api_key"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="api-access-col">
                <button type="submit" className="button b-type-primary b-size-normal b-color-green mt-4">Save</button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}
